import { useState } from "react";
import { useSelector } from "react-redux";
import DeleteModal from "../../../../../common/DeleteModal";
import FingerprintExclusionService from "../../../../../../services/HRM/FingerprintExclusionService";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const fingerprintExclusionService = new FingerprintExclusionService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.branchName}</td>
			<td
				style={{
					display: "grid",
					gridTemplateColumns: "auto auto",
					gap: "8px",
				}}>
				{item?.exclusions?.map((res, index) => (
					<span>
						{res?.employeeName}{" "}
						{index !== item?.exclusions?.length - 1 ? ", " : ""}
					</span>
				))}
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					<i
						className="la la-edit cursor-pointer"
						onClick={() => {
							setItem(item);
							setAddModal(true);
						}}></i>
					<i
						className="la la-trash cursor-pointer"
						onClick={() => setDeleteModal(true)}></i>
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.branchName}
					deletedItem={{ id: item?.branchId, ...item }}
					modelService={fingerprintExclusionService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
